export const BP_SHIFT_HORIZONTAL = 295.5;
export const BP_SHIFT_HORIZONTAL_TRINCA = 71;
export const BP_SHIFT_VERTICAL = 580;

export const BOARD_COLUMNS = 18;
export const BOARD_LINES = 14;
export const BOARD_BOTTOM_DESKTOP_PX = 8000;
export const BOARD_BOTTOM_MOBILE_PX = 7000;
export const BOARD_CENTER_DESKTOP_PX = 5000;
export const BOARD_CENTER_MOBILE_PX = 400;

export const CORE_SHIFT_HORIZONTAL = 593;
export const CORE_SHIFT_VERTICAL = 54;

export const BLOCKADE_SHIFT_HORIZONTAL = 591;

export const EXIT_SHIFT_VERTICAL = 100;
export const EXIT_SHIFT_HORIZONTAL_TRINCA = 625;
export const SIDE_PIECE_SHIFT_LEFT = 300;
export const SIDE_PIECE_SHIFT_LEFT_MOBILE = 600;

export const showDebugHelpers = false;
